module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "active-item-wrapper"
  }, [_c('div', {
    staticClass: "active-item-header"
  }, [_c('h4', {
    staticClass: "active-item-title is-margin-top-0",
    on: {
      "click": function($event) {
        _vm.showExtraInfo = !_vm.showExtraInfo
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.drag_editor.active_item.edit')))]), _vm._v(" "), (_vm.canDelete) ? _c('double-opt-in-delete', {
    on: {
      "delete": _vm.deleteElement
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "active-item-content"
  }, [_c('sensual-badge', {
    staticClass: "active-item-type-badge",
    attrs: {
      "color": "grey",
      "text": _vm.badgeText,
      "popperOptions": _vm.popperOptions
    }
  }), _vm._v(" "), (_vm.editorName == 'LeadMask' && _vm.item.isUniqueInCollection) ? _c('sensual-badge', {
    staticClass: "active-item-type-badge",
    attrs: {
      "color": "grey",
      "text": _vm.$t('ui.lead_mask_editor.default_field'),
      "popperOptions": _vm.popperOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editorName == 'LeadMask' && !['container_tab', 'title', 'paragraph', 'drawing', 'crawled_info'].includes(_vm.item.element_type)) ? _c('div', {
    staticClass: "element-columns"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('ui.lead_mask_editor.element_width')))]), _vm._v(" "), _c('button', {
    staticClass: "btn-switch col-12",
    class: {
      'active': _vm.item.class == 'col-12' || _vm.item.class == ''
    },
    on: {
      "click": function($event) {
        return _vm.setClassGrid('col-12', _vm.item)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-switch col-6",
    class: {
      'active': _vm.item.class == 'col-6'
    },
    on: {
      "click": function($event) {
        return _vm.setClassGrid('col-6', _vm.item)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-switch col-4",
    class: {
      'active': _vm.item.class == 'col-4'
    },
    on: {
      "click": function($event) {
        return _vm.setClassGrid('col-4', _vm.item)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.canEdit('content') && ['paragraph', 'confirmation'].includes(_vm.item.element_type)) ? _c('field', {
    ref: "content",
    staticClass: "editor-textarea",
    attrs: {
      "type": "textarea",
      "value": _vm.content,
      "label": _vm.$t('ui.drag_editor.fields.text')
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('content') && ['title', 'submit'].includes(_vm.item.element_type)) ? _c('field', {
    ref: "content",
    staticClass: "editor-textarea",
    attrs: {
      "type": "text",
      "value": _vm.content,
      "label": _vm.$t('ui.drag_editor.fields.text')
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('content') && ['paragraph', 'confirmation'].includes(_vm.item.element_type)) ? _c('field-filler', {
    attrs: {
      "elements": _vm.$refs,
      "element-name": "content",
      "values": _vm.textAreaHtmlElements
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('label') && !['paragraph', 'title'].includes(_vm.item.element_type)) ? _c('field', {
    attrs: {
      "type": "text",
      "value": _vm.label,
      "label": _vm.$t('ui.drag_editor.fields.label')
    },
    model: {
      value: (_vm.label),
      callback: function($$v) {
        _vm.label = $$v
      },
      expression: "label"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('validation')) ? _c('field', {
    attrs: {
      "type": "text",
      "value": _vm.validation,
      "label": _vm.$t('ui.drag_editor.fields.validation')
    },
    model: {
      value: (_vm.validation),
      callback: function($$v) {
        _vm.validation = $$v
      },
      expression: "validation"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('placeholder')) ? _c('field', {
    attrs: {
      "type": "text",
      "value": _vm.placeholder,
      "label": _vm.$t('ui.drag_editor.fields.placeholder')
    },
    model: {
      value: (_vm.placeholder),
      callback: function($$v) {
        _vm.placeholder = $$v
      },
      expression: "placeholder"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('allowed_values')) ? _c('drag-editor-item-options', {
    attrs: {
      "collection": _vm.allowedValues,
      "limitEditing": _vm.limitEditingLocal,
      "element_type": _vm.item.element_type,
      "defaultValue": _vm.defaultValue
    },
    on: {
      "input": _vm.changeAllowedValues,
      "updateDefault": _vm.changeDefaultValue,
      "delete": _vm.deleteAllowedValue
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasAllowedValues() && !_vm.limitEditingLocal) ? _c('div', [_c('button', {
    staticClass: "button link",
    on: {
      "click": _vm.addItem
    }
  }, [_c('span', {
    staticClass: "btn-plus"
  }, [_vm._v("+")]), _vm._v("\n        " + _vm._s(_vm.$t('ui.drag_editor.fields.add_item')) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.canEdit('default_value') && _vm.canEdit('allowed_values')) ? _c('field', {
    attrs: {
      "type": "hidden",
      "value": _vm.defaultValueOptions,
      "label": _vm.$t('ui.drag_editor.fields.default_value_options'),
      "disabled": true,
      "readonly": true
    }
  }) : (_vm.item.element_type == 'country_select') ? _c('country-select', {
    attrs: {
      "label": _vm.$t('ui.drag_editor.fields.default_value'),
      "language": _vm.language
    },
    model: {
      value: (_vm.defaultValue),
      callback: function($$v) {
        _vm.defaultValue = $$v
      },
      expression: "defaultValue"
    }
  }) : (_vm.canEdit('default_value') && !_vm.canEdit('allowed_values')) ? _c('field', {
    attrs: {
      "type": _vm.item.element_type,
      "value": _vm.defaultValue,
      "label": _vm.$t('ui.drag_editor.fields.default_value'),
      "disabled": _vm.canEdit('allowed_values')
    },
    model: {
      value: (_vm.defaultValue),
      callback: function($$v) {
        _vm.defaultValue = $$v
      },
      expression: "defaultValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('class') && _vm.editorName == 'ExternalForm') ? _c('field', {
    attrs: {
      "type": "text",
      "value": _vm.klass,
      "label": _vm.$t('ui.drag_editor.fields.class')
    },
    model: {
      value: (_vm.klass),
      callback: function($$v) {
        _vm.klass = $$v
      },
      expression: "klass"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('required')) ? _c('field', {
    attrs: {
      "defaultValue": false,
      "collection": [{
        value: true,
        name: _vm.$t('ui.drag_editor.fields.required')
      }],
      "type": "checkbox",
      "value": _vm.required,
      "name": "required",
      "params": {
        no_i18n: true
      },
      "label": "empty"
    },
    model: {
      value: (_vm.required),
      callback: function($$v) {
        _vm.required = $$v
      },
      expression: "required"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('hidden')) ? _c('field', {
    attrs: {
      "defaultValue": false,
      "collection": [{
        value: true,
        name: _vm.$t('ui.drag_editor.fields.hidden')
      }],
      "type": "checkbox",
      "value": _vm.hidden,
      "name": "hidden",
      "params": {
        no_i18n: true
      },
      "label": "empty"
    },
    model: {
      value: (_vm.hidden),
      callback: function($$v) {
        _vm.hidden = $$v
      },
      expression: "hidden"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('show_as_buttons')) ? _c('field', {
    attrs: {
      "defaultValue": false,
      "collection": [{
        value: true,
        name: _vm.$t('ui.drag_editor.fields.show_as_buttons')
      }],
      "type": "checkbox",
      "value": _vm.show_as_buttons,
      "name": "show_as_buttons",
      "params": {
        no_i18n: true
      },
      "label": "empty"
    },
    model: {
      value: (_vm.show_as_buttons),
      callback: function($$v) {
        _vm.show_as_buttons = $$v
      },
      expression: "show_as_buttons"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('enrich_tags') && _vm.editorName == 'LeadMask' && _vm.hasPermission('is_root')) ? _c('field', {
    attrs: {
      "defaultValue": false,
      "collection": [{
        value: true,
        name: _vm.$t('ui.drag_editor.fields.enrich_tags')
      }],
      "type": "checkbox",
      "value": _vm.enrich_tags,
      "name": "enrich_tags",
      "params": {
        no_i18n: true
      },
      "label": "empty"
    },
    model: {
      value: (_vm.enrich_tags),
      callback: function($$v) {
        _vm.enrich_tags = $$v
      },
      expression: "enrich_tags"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('data_type') && _vm.editorName == 'LeadMask') ? _c('field', {
    attrs: {
      "type": "select",
      "collection": _vm.dataTypes,
      "value": _vm.item.data_type,
      "label": _vm.$t('ui.drag_editor.fields.data_type')
    },
    model: {
      value: (_vm.data_type),
      callback: function($$v) {
        _vm.data_type = $$v
      },
      expression: "data_type"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shouldShowName(_vm.editorName)) ? _c('field', {
    attrs: {
      "type": "text",
      "readonly": _vm.item.isUniqueInCollection,
      "disabled": _vm.item.isUniqueInCollection,
      "value": _vm.item.name,
      "label": _vm.$t('ui.drag_editor.fields.internal_name')
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._l((Object.keys(_vm.item)), function(attribute) {
    return (_vm.showExtraInfo) ? _c('div', {
      directives: [{
        name: "can",
        rawName: "v-can",
        value: ('is_root'),
        expression: "'is_root'"
      }],
      key: attribute
    }, [_vm._v(_vm._s(attribute) + ": " + _vm._s(_vm.item[attribute]))]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bf087e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DragNDrop/DragItemEdit.vue
// module id = 1931
// module chunks = 0